
import React, { Component, Fragment } from 'react'
import { Dialog } from 'primereact/dialog';
import { Button } from "primereact/button";
// import EditorContainer from '../../activity/activityComponent/EditorContainer';
import CenterElement from '../../activity/activityComponent/CenterElement';

class SourceItemUI extends Component {


    state = {
        displayViewTxt: false

    }

    componentDidMount = () => {
        let { sourceItem } = this.props
        sourceItem.htmlRef = this.sourceRef
    }

    render = () => {

        let { sourceItem } = this.props

        return (
            <Fragment>
                <div className="mySource" ref={(e) => this.sourceRef = e} style={{ marginBottom: "10px" }} onClick={(e) => this.handlSourceClick(e, sourceItem)}>
                    {this.getSourceItemUI(sourceItem)}
                    <div ref={(e) => this.sourceRef = e}></div>
                </div>
            </Fragment>
        )
    }

    getSourceItemUI = (sourceItem) => {
        let { ConnectContainerModel } = this.props

        if (ConnectContainerModel.sourceType == ConnectContainerModel.TEXT_TYPE) {
            return this.getSourceItemUITxt(sourceItem)
        }
        else {
            return this.getSourceItemUIImgTxt(sourceItem)

        }
    }

    getSourceItemUITxt = (sourceItem) => {

        return (
            <div >
                <div class="card" style={{ marginBottom: "10px" }}>
                    <div class="card-body">
                        <i class="pi pi-circle-off" style={{ float: "right" }}></i> {sourceItem.sourceTxt}
                    </div>
                </div>
            </div>
        )
    }

    getSourceItemUIImgTxt = (sourceItem) => {
        let { activity, quizViewer } = this.props

        // let { selectedSourceStyle } = activity.ConnectContainerModel

        // let uiStyle = JSON.parse(JSON.stringify(selectedSourceStyle))
        let { quizViwerModel } = quizViewer.state
        let Img = sourceItem.hasExternalUrl ? sourceItem.sourceImg : (activity.matchingUrl + sourceItem.sourceImg)

        return (
            <Fragment>   <div class="card">
                <div class="card-body">
                    <div>
                        {/* className={uiStyle[2].class} style={uiStyle[2].style} */}
                        <i class="pi pi-circle-off" style={{ float: "right" }}></i>
                        <img style={{ width: "100%" }} src={Img} onClick={this.showImgRes} />
                    </div>
                    <div hidden={activity.ConnectContainerModel.sourceType == 1}>
                        {/* style={uiStyle[3].style} */}
                        {/* <EditorContainer onChange={(e) => { sourceItem.sourceTxt = e.target.getContent() }} content={quizViewer.getTxt(sourceItem.sourceTxt)} /> */}

                        {sourceItem.sourceTxt}
                    </div>
                </div>
            </div>

            </Fragment>
        )
    }

    handleRemoveSourceItem = (e) => {
        let { activity, quizViewer, sourceItem } = this.props
        activity.ConnectContainerModel.removeSourceItem(sourceItem.sourceIndex)
        quizViewer.setState({})
    }

    handleTestAftersource = (e) => {
        this.setState({ displayViewTxt: true })
    }

    showImgRes = () => {
        let { quizViewer } = this.props
        quizViewer.ImgResRef.showPanel(this.updateImgSrc)
    }
    updateImgSrc = (imgRes) => {
        let { sourceItem, activity, quizViewer } = this.props
        if (imgRes.hasExternalUrl) {
            sourceItem.sourceImg = imgRes.externalUrl
            sourceItem.hasExternalUrl = true;
        } else
            sourceItem.sourceImg = imgRes.resourceRelativePath

        quizViewer.ImgResRef.hidePanel()
        quizViewer.setState({})

    }

    // handlSourceClick = (e,sourceItem) => {
    //     let { ConnectContainerModel } = this.props
    //     ConnectContainerModel.currentSource = sourceItem
    //     ConnectContainerModel.currentSourceHtml = e.target
    // }


    handlSourceClick = (e) => {
        let { activity, sourceItem } = this.props
        activity.currentSelectedSource = sourceItem;
    }

    getHtmlRef = () => {
        return this.sourceRef
    }

}

export default SourceItemUI